import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface AppConfig {
  apiServerUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class UrlConfigService {
  constructor(private http: HttpClient) {}

  private apiServerUrlSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  apiServerUrl!: string;

  loadAppConfig() {
    this.http.get<AppConfig>('/assets/path.json').subscribe({
      next: (data: AppConfig) => {
        this.apiServerUrl = data.apiServerUrl;
        this.apiServerUrlSubject.next(data.apiServerUrl);
      },
    });
  }

  getApiUrl(): string {
    return this.apiServerUrlSubject.getValue();
  }
}
